import { AssetLocation, PointGeometry } from "../logic/api";

export interface ParsedGpsLocationInput {
  valid: boolean;
  point: PointGeometry | null;
}

export function parseLatLngInput(input: string): ParsedGpsLocationInput {
  const trimmed = input.trim();
  if (trimmed === "") {
    return { valid: true, point: null };
  }
  const parts = trimmed.split(",");
  const [latStr, lngStr] = parts.map((p) => p.trim());
  if (parts.length !== 2) return { valid: false, point: null };
  const isValidCoordinate = (coordinate: string) => /^-?\d+\.\d{3,}$/.test(coordinate);
  if (!isValidCoordinate(latStr) || !isValidCoordinate(lngStr)) {
    return { valid: false, point: null };
  }
  const lat = Number(latStr);
  const lng = Number(lngStr);

  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return { valid: false, point: null };
  }

  return { valid: true, point: { type: "Point", coordinates: [lng, lat] } };
}

/** Formats a GeoJSON Point back into "latitude, longitude" text for display. */
export function formatLatLngInput(gpsLocation: AssetLocation["gpsLocation"]): string {
  if (gpsLocation?.type === "Point") {
    const [lng, lat] = gpsLocation.coordinates;
    return `${lat},${lng}`;
  }
  return "";
}
